module.exports = "a1aeb6e4535c9c6e467fc047e6e10026.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-top-r-1.png
// module id = 58
// module chunks = 0